import { render, staticRenderFns } from "./CreateParamGroupModal.vue?vue&type=template&id=54843482&scoped=true"
import script from "./CreateParamGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateParamGroupModal.vue?vue&type=script&lang=js"
import style0 from "./CreateParamGroupModal.vue?vue&type=style&index=0&id=54843482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54843482",
  null
  
)

export default component.exports